<template>
	<div>
		<experienceOverview v-if="pageType === 'experienceOverview'"
			:checkedFacets="checkedFacets" 
			:facets="facets"
			:overviewSettings="overviewSettings"
			:isLoading="isLoading"
			:pageCount="pageCount"
			:hasPreviousPage="hasPreviousPage"
			:currentPage="currentPage"
			:hasNextPage="hasNextPage"
			:openFilter="openFilter"
			:searchResults="searchResults"
		/>
		<defaultSearchResultOverview v-else
			:checkedFacets="checkedFacets" 
			:facets="facets"
			:overviewSettings="overviewSettings"
			:isLoading="isLoading"
			:pageCount="pageCount"
			:hasPreviousPage="hasPreviousPage"
			:currentPage="currentPage"
			:hasNextPage="hasNextPage"
			:openFilter="openFilter"
			:searchResults="searchResults"
		/>
		
	</div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import azuresearch, { AzureSearchApiSettings, AzureSearchRequest, AzureSearchGui, AzureSearchFacetDefinition, AzureSearchSearchSettings, AzureSearchApi } from '@frontisbv/scheffer-azuresearch-searchclient';
import defaultSearchResultOverview from './components/defaultSearchResultOverview.vue';
import experienceOverview from './components/experienceOverview.vue';
import _ from 'lodash';

export default {
	components: {
		defaultSearchResultOverview,
		experienceOverview
	},
	props: ['azureSearchSettings', 'overviewSettings','pageType'],
	data() {
		return {
			searchRequest: null,
			searchRequestFilter: '',
			searchRequestSearchParam: '*',
			searchResults: [],
			lastChangedFilter: '', // = filter name
			checkedFacets: [],
			facets: {},
			count: 0,
			currentPage: 1,
			openFilter: null,
			isLoading: true
		};
	},
	computed: {
		pageCount: function () {
			if (this.searchRequest.top === 0) return 1;

			return Math.ceil(this.count / this.searchRequest.top);
		},
		hasPreviousPage: function () {
			return this.currentPage > 1;
		},
		hasNextPage: function () {
			return this.currentPage < this.pageCount;
		}
	},
	async created() {
		// when page is given in the URL (only Google results), set it and remove it from the URL
		if (!_.isEmpty(this.$route.query) && !_.isEmpty(this.$route.query.pageNr)) {
			this.currentPage = parseInt(this.$route.query.pageNr);
		}

		this.searchApi = this.setSearchApi();
		this.searchRequest = this.setSearchQuery();

		// set filters out of the URL (params)
		this.setFiltersByUrlParams();

		await this.search();
	},
	methods: {
		async search() {
			this.addFiltersToSearchRequest();

			this.searchRequest.search = this.searchRequestSearchParam;
			this.searchRequest.filter = this.searchRequestFilter;
			if (this.overviewSettings.IndexName === 'agruniek-articles' || this.overviewSettings.IndexName === 'agruniek-experiences') {
				this.searchRequest.orderBy = 'DocumentDate desc'; // articles
			} else {
				this.searchRequest.orderBy = 'FirstName asc'; // specialists
			}
			this.searchRequest.skip = (this.currentPage - 1) * this.searchRequest.top;

			try {
				var response = await this.searchApi.search(this.searchRequest);
				this.searchResults = response.data.value;
				this.count = response.data['@odata.count'];
				this.setFacets(response.data['@search.facets']);
			} catch (e) {
				console.error(e);
			}
			this.isLoading = false;
		},
		getPresentationDate: function (dateString) {
			const unixTimestamp = Date.parse(dateString);

			var a = new Date(unixTimestamp);
			var months = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
			var year = a.getFullYear();
			var month = months[a.getMonth()];
			var day = a.getDate();

			return day + ' ' + month + ' ' + year;
		},
		getSectorName: function (name) {
			if (name.toString().includes('.')) {
				var subsectorName = name.split('.');
				return subsectorName[1];
			}
			return name;
		},
		getFilterName: function (name) {
			if (name === 'Theme') {
				return this.overviewSettings.FilterThemes;
			}
			return this.overviewSettings.FilterSectors;
		},
		setSearchApi: function () {
			const settings = new azuresearch.AzureSearchSearchSettings({
				apiSettings: {
					searchServiceName: this.azureSearchSettings.ServiceName,
					searchServiceQueryApiKey: this.azureSearchSettings.ServiceQueryApiKey,
					indexName: this.overviewSettings.IndexName,
					apiVersion: this.azureSearchSettings.ApiVersion,
					url: this.azureSearchSettings.Url
				}
			});

			return new azuresearch.AzureSearchApi(settings);
		},
		setSearchQuery: function () {
			var result = new azuresearch.AzureSearchRequest({
				search: this.searchRequestSearchParam,
				select: this.overviewSettings.ColumnNames,
				facets: this.overviewSettings.FacetNames,
				top: this.overviewSettings.PageSize,
				skip: 0,
				count: true
			});

			return result;
		},
		setFiltersByUrlParams: function () {
			if (!_.isEmpty(this.$route.query)) {
				if (!_.isEmpty(this.$route.query.Sector)) {
					var multipleSectors = this.$route.query.Sector.split('|');
					this.checkedFacets.Sector = multipleSectors || [this.$route.query.Sector];
				}
				if (!_.isEmpty(this.$route.query.Theme)) {
					var multipleThemes = this.$route.query.Theme.split('|');
					this.checkedFacets.Theme = multipleThemes || [this.$route.query.Theme];
				}
			}
		},
		setFiltersToRoute: function () {
			const currentRoute = this.$router.currentRoute;
			var queryParams = [];

			for (var facetKey in this.checkedFacets) {
				var facetValue = this.checkedFacets[facetKey]; // array of values (checked filters)
				queryParams[facetKey] = facetValue.join('|');
			}

			this.$router.replace({ path: currentRoute.path, query: queryParams });
		},
		updateFilters: function (event, filtertype) {
			if (filtertype) {
				this.lastChangedFilter = filtertype;
			} else {
				this.lastChangedFilter = event.target.id.substring(0, event.target.id.indexOf('_'));
			}

			const curValue = event.target.value;

			// Uncheck subsectors
			if (!curValue.includes('.')) {
				const allFilters = document.querySelectorAll('.c-filter__item--list input');
				for (let i = 0; i < allFilters.length; i++) {
					if (allFilters[i].value.startsWith(curValue + '.')) {
						allFilters[i].checked = false;
					}
				}
			}

			if ((event.target.type === 'checkbox' && !event.target.checked) || !curValue) {
				// deactivating a filter option
				this.checkedFacets[this.lastChangedFilter] = this.checkedFacets[this.lastChangedFilter].filter((item) => !item.startsWith(curValue));

				if (this.checkedFacets[this.lastChangedFilter].length === 0) {
					delete this.checkedFacets[this.lastChangedFilter];
				}
			} else {
				// activating a filter option
				this.addFilterValue(this.lastChangedFilter, curValue);
			}

			this.setFiltersToRoute();

			// (re)set page to 1 and search
			this.setCurrentPage(1);
		},
		addFilterValue(key, value) {
			if (!this.checkedFacets[key]) {
				this.checkedFacets[key] = [value];
			} else {
				this.checkedFacets[key].push(value);
			}
		},
		checkedFacetsCount: function (key) {
			if (this.checkedFacets[key] !== undefined) return this.checkedFacets[key].length;

			return 0;
		},
		resetFilters: function (event) {
			this.checkedFacets = [];
			this.setFiltersToRoute();

			// (re)set page to 1 and search
			this.setCurrentPage(1);
		},
		addFiltersToSearchRequest: function () {
			var filter = '';

			if (this.overviewSettings.DefaultFilter) filter = this.overviewSettings.DefaultFilter;

			if (this.checkedFacets !== undefined) {
				for (var key in this.checkedFacets) {
					if (this.checkedFacets[key]) {
						var values = this.checkedFacets[key];

						for (var value in values) {
							if (value) {
								filter += filter.length > 0 ? ' and ' : '';
								filter += key + "/any(item: item eq '" + values[value].replace("'", "''") + "')";
							}
						}
					}
				}
			}

			this.searchRequestFilter = filter;
		},
		setFacets: function (newFacets) {
			for (var key in newFacets) {
				this.facets[key] = _.orderBy(newFacets[key], [(item) => item.value.toLowerCase()], 'asc');
			}

			this.$forceUpdate();
		},
		isFilterValueChecked: function (facet, value) {
			return this.checkedFacets[facet] && this.checkedFacets[facet].indexOf(value) >= 0;
		},
		previousPage: function () {
			const newPageNr = +this.currentPage - 1;
			this.setCurrentPage(newPageNr);
		},
		nextPage: function () {
			const newPageNr = +this.currentPage + 1;
			this.setCurrentPage(newPageNr);
		},
		setCurrentPageByEvent: function (event) {
			const newPageNr = event.target.value;
			this.setCurrentPage(newPageNr);
		},
		setCurrentPage: function (pageNr) {
			document.getElementById('articles').scrollIntoView();

			if (pageNr < 1) {
				pageNr = 1;
			}
			this.currentPage = pageNr;

			// keep page number in URL up-to-date
			const currentRoute = this.$router.currentRoute;
			if (pageNr > 1) {
				this.$router.replace({ path: currentRoute.path, query: { pageNr: pageNr } });
			} else if (pageNr === 1 && currentRoute.query.pageNr !== undefined && currentRoute.query.pageNr > 1) {
				this.$router.replace(currentRoute.path);
			}

			this.search();
		},
		toggleFilter: function (event) {
			const body = document.body;
			const filterButton = event.target;
			const filterName = filterButton.dataset.filtername;

			if (this.openFilter === filterButton.dataset.filtername) {
				this.openFilter = null;
				body.classList.remove('open-filter');
			} else {
				this.openFilter = filterName;
				body.classList.add('open-filter');
			}
		},
		closeFilter: function () {
			const body = document.body;
			body.classList.remove('open-filter');
			this.openFilter = null;
		},
		showDate(item) {
			if (item === 'News' || item === 'Knowledge') {
				return true;
			}

			return false;
		}
	}
};
</script>
